const marketplaces = [
  {
    id: 1,
    name: "Worten",
    img: require(`@/assets/images/marketplaces/worten.jpg`)
  },
  {
    id: 2,
    name: "Fnac",
    img: require(`@/assets/images/marketplaces/fnac.jpg`)
  },
  {
    id: 3,
    name: "Tien 21",
    img: require(`@/assets/images/marketplaces/tien21.jpg`)
  },
  {
    id: 4,
    name: "Auchan",
    img: require(`@/assets/images/marketplaces/auchan.jpg`)
  }
];

export function index() {
  return marketplaces;
}
